import { render, staticRenderFns } from "./naj-action-button.vue?vue&type=template&id=59c371b3&"
import script from "./naj-action-button.vue?vue&type=script&lang=js&"
export * from "./naj-action-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports